<template>
  <v-slide-y-transition mode="out-in">      
    <div>
      <v-tabs      
        dark v-model="active"
        v-bind:color="kompetisi ? kompetisi.color : 'black'"
        show-arrows      
      >    
        <v-tabs-slider color="yellow"></v-tabs-slider>      
        <v-tab v-for="(item, i) in tabs" :key="i">{{item.name}}</v-tab>            
        <v-tabs-items>
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
          <v-tab-item v-for="(item, i) in tabs" :key="i">
            <v-card flat>            
              <v-card-text>
                <v-card v-if="kompetisi">
                  <v-toolbar>
                    <v-text-field flat solo append-icon="search" placeholder="Type something" v-model="item.areaSearch" hide-details></v-text-field>
                    <v-tooltip bottom>
                      <v-btn slot="activator" :loading="loading" icon @click="refreshKompetisi(i)">
                        <v-icon>refresh</v-icon>            
                      </v-btn>
                      <span>Refresh</span>
                    </v-tooltip>                   
                    <v-spacer></v-spacer> 
                    <v-btn-toggle v-model="modeView">
                      <v-btn flat value="list">
                        <span>List</span>
                        <v-icon>list</v-icon>
                      </v-btn>
                      <v-btn flat value="card">
                        <span>Card</span>
                        <v-icon>dashboard</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                    <v-dialog v-model="dialog_manual" width="700">
                      <v-chip dark color="info" slot="activator">                      
                        WAJIB BACA INI DULU, Click this !
                      </v-chip>

                      <v-card>
                        <v-toolbar dense class="grey lighten-2">
                          <v-toolbar-title dense class="headline" primary-title>User Manual</v-toolbar-title>
                        </v-toolbar>
                        
                        <v-card-text>
                          <p>Untuk mengaktifkan fitur ini ikuti langkah berikut :</p>
                          <ol>
                            <li>Klik kanan pada shortcut google chrome di dekstop, lalu click properties.</li>
                            <li>Copy code berikut :
                              <br/>
                              
                              <strong class="my-4 py-3">--disable-web-security --disable-gpu --user-data-dir=~/chromeTemp</strong>
                              <br/>
                              
                              dan paste sesuai petunjuk Gambar dibawah ini :<br/>
                              <img src="@/assets/img/nocors.png" style="max-width:400px;" /><br/>
                              <img src="@/assets/img/nocors2.png" style="max-width:400px;" /><br/>
                            </li>
                            <li>Buka browser tersebut menggunakan "run as administrator"</li>
                            <li>dan terakhir, silahkan kunjungi kembali halaman ini</li>
                          </ol>
                          <p class="mt-3">NB : Data Pie disebelah kanan adalah data live realcount PILPRES dari web resmi KPU. Enjoy it :)</p>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions><v-spacer></v-spacer><v-btn color="primary" flat @click="dialog_manual = false">I accept</v-btn></v-card-actions>
                      </v-card>
                    </v-dialog>                    
                    <!--<v-chip dark v-bind:color="quickcountMode?'warning':'success'">                      
                      <v-switch :disabled="true" v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
                      ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
                    </v-chip>-->
                  </v-toolbar>
                  <template v-if="!item.areaSearch && item.show">
                    <v-card-text class="pa-1">
                      <v-layout row wrap>
                        <v-flex lg6 sm6 xs12 class="pa-2">                                                  
                          <template>
                            <e-chart :key="'a'+(item.time+item.id)" v-if="!quickcountMode" v-bind:option="setPieOption(item)" height="250px" width="100%" />                  
                            <e-chart :key="'b'+(item.time+item.id)" v-else v-bind:option="setPieOption(item, true)" height="250px" width="100%"/>                                                                                   
                            <table style="width:100%" v-if="!quickcountMode">
                              <tr>
                                <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">store</v-icon> {{item.contain?item.contain.done:0}}</span>/<small>{{item.contain?item.contain.all:0}} tps</small></td>
                                <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{item.sah.tdk_sah?item.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                              </tr>                        
                            </table>            
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(item.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(item.contain))">trending_up</v-icon> {{persenContain(item.contain)}}% </span> to complete</td></td>
                                <td class="text-xs-right"><v-chip :color="item.color" small dark>
                                  <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                                  <small>{{item.sah.updated_at?$moment(item.sah.updated_at*1000).fromNow():null}}</small></v-chip></td></td>
                              </tr>                        
                            </table>     
                          </template>
                        </v-flex>
                        <v-flex lg6 sm6 xs12 class="pa-2" v-if="item.kpushow">
                          <template>
                            <e-chart :key="'e'+(item.time+item.id)" v-bind:option="setPieOptionKpu(item)" height="250px" width="100%" />                                                   
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">store</v-icon> {{item.kpucontain?item.kpucontain.done:0}}</span>/<small>{{item.kpucontain?item.kpucontain.all:0}} tps</small></td>
                                <td class="text-xs-right"><span class="caption">{{item.kpuupdated?$moment(item.kpuupdated).add(7, 'hours').format('DD-MM-YYYY HH:mm'):null}}  <v-icon color="light-green">event</v-icon></span></td>
                              </tr>                        
                            </table>  
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(item.kpucontain))+'--text'"><v-icon small :color="colorPersen(persenContain(item.kpucontain))">trending_up</v-icon> {{persenContain(item.kpucontain)}}% </span> to complete</td></td>
                                <td class="text-xs-right"><v-chip :color="item.color" small dark>
                                  <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                                  <small>{{item.kpuupdated?$moment(item.kpuupdated).add(7, 'hours').fromNow():null}}</small></v-chip></td></td>
                              </tr>                        
                            </table> 
                          </template>                                                
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </template>  
                </v-card>
                <v-card class="mt-3" v-if="modeView==='list'">
                  <v-card-text>                    
                    <v-data-table
                      :headers="tabs[i].tableheader"                      
                      :items="tabs[i].tablebody"  
                      :pagination.sync="pagination"
                      hide-actions
                      >
                      <template slot="items" slot-scope="props">                             
                        <tr>      
                          <td class="cursor" @click="newTab(props.item.data,i+1)">{{props.index+1}}</td>
                          <td class="cursor" @click="newTab(props.item.data,i+1)">{{props.item.area_name}} ({{props.item.persen}}%)</td>
                          <td class="text-xs-right">{{props.item.real_01}}</td>
                          <td class="text-xs-right">{{props.item.real_02}}</td>
                          <td class="text-xs-right">{{props.item.kpu_01}}</td>
                          <td class="text-xs-right">{{props.item.kpu_02}}</td>
                          <td class="text-xs-right" :class="props.item.kpu_01 - props.item.real_01 !== 0 ? props.item.kpu_01 - props.item.real_01>0? 'orange--text':'red--text':'green--text'">{{props.item.kpu_01 - props.item.real_01>0?'+':''}}{{props.item.selisih_01 = props.item.kpu_01 - props.item.real_01}}</td>
                          <td class="text-xs-right" :class="props.item.kpu_02 - props.item.real_02 !== 0 ? props.item.kpu_02 - props.item.real_02>0? 'orange--text':'red--text':'green--text'">{{props.item.kpu_02 - props.item.real_02>0?'+':''}}{{props.item.selisih_02 = props.item.kpu_02 - props.item.real_02}}</td>
                          <td>
                            <span style="display:none">{{props.item.ket = isMatching(props.item.data)}}</span>
                            <v-icon v-if="isMatching(props.item.data) === 2" color="green" v-else>check_circle</v-icon>
                            <v-icon v-else-if="isMatching(props.item.data) === 1" color="orange" v-else>priority_high</v-icon>
                            <v-icon color="red" v-else>warning</v-icon>                            
                          </td>
                        </tr>
                      </template>
                    </v-data-table>                    
                  </v-card-text>
                  <v-card-actions v-if="tabs[i].area.data.length < tabs[i].area.count">
                    <v-btn class="my-0" color="info" :loading="loading" dark @click="setAreas(tabs[i])">load more ...</v-btn>                    
                  </v-card-actions>  
                </v-card>                
                <v-container grid-list-lg fluid pa-0 mt-3 pb-3 v-else>
                  <v-layout row wrap>
                    <v-flex lg4 sm6 xs12 v-for="(data, n) in tabs[i].area.data">                      
                      <v-card class="cursor elevation-3" @click="newTab(data,i+1)">
                        <v-toolbar dense flat class="white pa-0">
                          <v-toolbar-title class="sub-title ma-0">{{data.name}}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2"> 
                          <v-container grid-list-lg class="pa-0">
                            <v-layout row wrap>
                              <v-flex xs6>
                                <div class="chart mr-2">
                                  <e-chart :key="'c'+item.time" v-if="!quickcountMode" v-bind:option="setPieOption2(data)" height="150px" width="100%"/>                  
                                  <e-chart :key="'d'+item.time" v-else v-bind:option="setPieOption2(data, true)" height="150px" width="100%"/>                                                                                   
                                </div>                                      
                              </v-flex>
                              
                              <v-flex xs6>
                                <div class="chart mr-2">
                                  <e-chart :key="'f'+item.time" v-bind:option="setPieOption2Kpu(data)" height="150px" width="100%"/>                  
                                </div>                                                                      
                              </v-flex>
                              <v-flex xs12>
                                <table class="tb-berlebih" style=" margin-top: -15px" v-if="!quickcountMode">
                                  <tr><td colspan="3" class="text-xs-center">Match Data</td></tr>
                                  <tr v-for="(calon, i) in data.calons">                                    
                                    <td>0{{calon.no}}</td>
                                    <td>{{calon.akronim}}</td>
                                    <td class="text-xs-right" :class="(data.kpucalons[i].suara - calon.hitung.suara)!=0?(data.kpucalons[i].suara - calon.hitung.suara)>0?'orange--text':'error--text':'green--text'">{{(data.kpucalons[i].suara - calon.hitung.suara)>0?'+':''}}{{data.kpucalons[i].suara - calon.hitung.suara}}</td>
                                  </tr>                        
                                </table>
                              </v-flex>
                              <v-flex xs12 pt-0 mt-0 mb-0 pb-0>
                                <table style="width:100%;" v-if="!quickcountMode">
                                  <tr>
                                    <td class="text-xs-left"><span class="caption blue--text"><v-icon small color="blue">store</v-icon> {{data.contain?data.contain.done:0}}</span>/<small>{{data.contain?data.contain.all:0}} tps</small></td>                                
                                    <!--<td class="text-xs-right"><span class="caption red--text">{{data.sah.tdk_sah?data.sah.tdk_sah:0}}  <v-icon small color="red">layers_clear</v-icon></span></td>-->
                                  </tr>                        
                                </table>            
                                <v-divider></v-divider>
                                <table style="width:100%">
                                  <tr>
                                    <td class="text-xs-left"><span class="caption" :class="colorPersen(persenContain(data.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(data.contain))">trending_up</v-icon> {{persenContain(data.contain)}}% </span></td>
                                    <td class="text-xs-right"><span class="caption" :class="colorPersen(tabs[i].tablebody[n].persen)+'--text'"><v-icon small :color="colorPersen(tabs[i].tablebody[n].persen)">trending_up</v-icon> {{tabs[i].tablebody[n].persen}}% </span></td>                              
                                    <!--<td class="text-xs-right">                                
                                      <small>{{data.sah.updated_at?$moment(data.sah.updated_at*1000).fromNow():null}}</small>&nbsp;
                                      <v-icon small>alarm</v-icon>
                                    </td>-->
                                  </tr>                        
                                </table>
                              </v-flex>
                              <v-flex xs12>                                
                                <v-alert :value="true" type="success" v-if="isMatching(data) === 2">
                                  This area is matching.
                                </v-alert>
                                <v-alert :value="true" type="warning" v-else-if="isMatching(data) === 1">
                                  One of participant is not matching.                                  
                                </v-alert>
                                <v-alert :value="true" type="error" v-else>
                                  This area is not matching.                                  
                                </v-alert>
                              </v-flex>
                            </v-layout>
                          </v-container>  
                        </v-card-text>
                      </v-card>             
                    </v-flex>
                    <v-flex lg4 sm6 xs12 v-if="tabs[i].area.data.length < tabs[i].area.count">
                      <v-btn class="my-0" block color="info" :loading="loading" small dark @click="setAreas(tabs[i])">load more ...</v-btn>
                    </v-flex>  
                  </v-layout> 
                </v-container>
                
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <form-dialog :dialog="dialog" :cekup="cekup" v-on:closeDialog="closeDialog($event)"></form-dialog>
    </div>  
  </v-slide-y-transition>
</template>

<script>  
import EChart from '@/components/chart/echart';    
import DPie   from '../../components/data-chart/pie-1';
import DPie2  from '../../components/data-chart/pie-2';
import Model  from '@/apps/frc/models/Matching';
import FormDialog from './dialog';
const  model = new Model();

export default {    
    components: {
      EChart,
      FormDialog
    },
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      modeView : 'card',
      tabs : [],
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,                      
      formPath : '/kompetisi/form',      
      loading  : true,
      pagination : {'sortBy': 'area_name', 'descending': false, 'rowsPerPage': -1},      
      quickcountMode : false,      
      maxvalue: 0,
      dialog : false,
      cekup  : {
        kompetisi_id : null,
        tps_id : null,
        mode : null,
      },          
      kpucalons: null,
      dialog_manual : null,
    }),     
    watch:{      
    },
    asyncComputed:{
      back(){
        if(this.$route.query.area_ids){
          let a_ids = this.$route.query.area_ids;
          let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
          if((this.tabs.length-1) > area_ids.length){
            this.active = (area_ids.length);          
          }
        } else {
          this.active = 0;
        }
        return true;
      }
    },
    mounted(){ this.init();},        
    created () {},
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},                
        
        resize(){
            setTimeout(function(){
              window.getApp.$emit('RESIZE-ECHART');
            },100);            
        },
        
        closeDialog(e){
          this.dialog = e.dialog;
          this.cekup  = e.cekup;             
        },
        
        init(){                      
          if(this.kompetisi_id !== this.$route.query.kompetisi_id){
            this.loading = true;            
            this.kompetisi_id = this.$route.query.kompetisi_id;
            model.kompetisi({id:this.$route.query.kompetisi_id}).then(res=>{                  
                let index = 0;                 
                this.kompetisi = res.data;                       
                this.newTab(res.data,index);

                if(this.$route.query.area_ids){   
                    this.loading = true;
                    let a_ids = this.$route.query.area_ids;
                    let t_ids = this.$route.query.tingkat_ids;                      
                    let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
                    let tingkat_ids = Array.isArray(t_ids) ? t_ids : [t_ids];

                    let arr = this.urutkan(tingkat_ids, area_ids);                      
                    this.setTabs(arr);                                           
                } 
            });
          }                                        
        },
        
        newTab(data, i){
            if(data.tingkat < 5){   
                for(let j=this.tabs.length; j >= i ; j--){
                    this.tabs.splice(j, 1);                    
                }
                
                if(!this.tabs[i]){                    
                    this.tabs.push({name:data.name, calons:data.calons, kpudata:{}, kpuurl:this.tabs[i-1] && this.tabs[i-1].kpuurl?this.tabs[i-1].kpuurl+'/'+data.area_id:'hhcw/ppwp', kpucalons:[], kpushow:false, area_ids:[],show:false , tingkat_ids:[],areaSearch:null, area:{data:[], count:0, page:1, time:null}});                                 
                    this.loading = true;
                    model.kpuJson('ppwp.json').then(res=>{if(res.status === 200){let calons = res.data; this.kpucalons = res.data;
                      model.kpuJson(this.tabs[i].kpuurl+'.json').then(resp=>{
                        if(resp.status === 200){   
                          this.tabs[i].kpucalons = [];
                          let kpudata = resp.data;                           
                          for(var key in resp.data.chart){
                            if(!calons[key]) continue;
                            let chart = resp.data.chart;                            
                            this.tabs[i].kpucalons.push({id:key, no:calons[key].nomor_urut, name:calons[key].nama , suara: chart[key], color:calons[key].warna});
                          }                          
                          this.tabs[i].kpudata    = kpudata;
                          this.tabs[i].kpucontain = {all:kpudata.progress.total,done:kpudata.progress.proses};
                          this.tabs[i].kpuupdated = kpudata.ts;
                          this.tabs[i].kpushow= true;
                          this.setAreas(this.tabs[i], true);
                        }
                      })
                    }});                                        
                    setTimeout(()=>{this.tabs[i].show= true;},200);
                }                   
                
                Object.assign(this.tabs[i], data);                
                this.$watch(['tabs',i,'areaSearch'].join('.'), (val)=>{ 
                    const ctx = this; setTimeout(function(){
                       if(ctx.tabs[i] && val === ctx.tabs[i].areaSearch){
                          ctx.setAreas(ctx.tabs[i], true); 
                       }
                    }, 700);                    
                });
                                
                this.setCalons(i);
                this.active = i;                                
                
                if(i > 0){                                    
                  var area_ids = []; var tingkat_ids = []; 
                  for(let j=1; j<this.tabs.length; j++){
                      area_ids.push(this.tabs[j].area_id);
                      tingkat_ids.push(this.tabs[j].tingkat);
                  }
                  this.hitungRoute(area_ids, tingkat_ids); 
                }        
                
                
            } else {   
              let totsuarakpu = 0;
              data.kpucalons.forEach(calonkpu=>{
                totsuarakpu += calonkpu.suara;
              });              
              
              if(data.sah && data.sah.sah > 0 || totsuarakpu>0){                
                this.showDialog(this.kompetisi.id, data.id, this.kompetisi.mode, data.kputpsid, data.kpuurl);
              } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,text : 'No Data Result', color: 'warning'
                });
              }
              //this.formRoute(data.id);                
            }
        },
        
        showDialog(kompetisi_id, tps_id, mode, kputpsid, kpuurl){                        
            Object.assign(this.cekup, {kompetisi_id : kompetisi_id, tps_id:tps_id, mode:mode, kputpsid:kputpsid, kpuurl:kpuurl});
            this.dialog = true;
        },
        
        setCalons(i){ 
            this.tabs[i].calons.forEach((item, j)=>{                
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                this.tabs[i].calons[j].value = value;                
            });
            
        },
        
        refreshKompetisi(i){          
          let fm = this.tabs[i];          
          this.loading =true;
          if(i > 0){
            model.areas({tingkat:fm.tingkat,'AreaSearch[id]':fm.area_id,kompetisi_id:this.$route.query.kompetisi_id}).then(res=>{
                Object.assign(fm, res.data.data[0]);
                this.setCalons(i);
                this.setAreas(fm, true);
            });
          } else {
            model.kompetisi({id:this.$route.query.kompetisi_id,tingkat:fm.tingkat,area_id:fm.area_id}).then(res=>{                  
                Object.assign(fm, res.data);
                this.setCalons(i);
                this.setAreas(fm, true);            
            });
          }
        },
        
        async setTabs(arr){
            var index = 1;
            for(var i in arr){
                let res = await model.areas({tingkat:arr[i].a,'AreaSearch[id]':arr[i].b,kompetisi_id:this.kompetisi_id});
                this.newTab(res.data.data[0], index++);                
            }
        },                
          
        persenContain(contain){
            return this.quickcountMode?(contain.quick/contain.all*100).toFixed(2):(contain.done/contain.all*100).toFixed(2);
        },

        colorPersen(persen){
            if(persen >= 0 && persen <=40)return 'red';
            else if(persen <=60)return 'orange';
            else if(persen <=80)return 'yellow';
            else if(persen <=99)return 'blue';
            else return 'green';        
        },
        
        firstLetter (name) {
            return name.charAt(0);
        },                
        
        setAreas(fm, reset = false){            
            this.loading = true;    
            if(!fm) return;
            if(reset) fm.area.page = 1;
            model.areas({tingkat: (parseInt(fm.tingkat) + 1), kompetisi_id:this.kompetisi_id,'AreaSearch[parent_id]':fm.area_id, page:fm.area.page, 'AreaSearch[name]':fm.areaSearch}).then(resp=>{
                if(reset) {fm.area.data = []; fm.area.page = 1;}                                
                fm.area.data    = [...fm.area.data, ...resp.data.data];                
                fm.area.page++;
                fm.area.count = resp.data.count; 
                fm.area.time  = resp.data.time; 
                
                fm.tableheader = [{text:'No',value:'no',sortable:false},{text:'Area',value:'area_name'}];
                fm.tablebody   = [];
                fm.calons.forEach((calon)=>{
                  let str = calon.no;
                  str = String(str).replace(' ','').toLowerCase().substring(0,2);                  
                  fm.tableheader.push({align:'right',text:'real 0'+str,value:'real_0'+str}); 
                });
                fm.kpucalons.forEach((calon)=>{
                  let str = calon.name;
                  str = String(str).replace(' ','').toLowerCase().substring(1,3);                  
                  fm.tableheader.push({align:'right',text:'KPU '+str,value:'kpu_'+str});
                });
                fm.calons.forEach((calon)=>{
                  let str = calon.no;
                  str = String(str).replace(' ','').toLowerCase().substring(0,2);                  
                  fm.tableheader.push({align:'right',text:'Selisih 0'+str,value:'selisih_0'+str}); 
                });
                
                fm.tableheader.push({align:'center',text:'ket',value:'ket'});
                
                if(fm.tingkat < 4){                
                  fm.area.data.forEach(data=>{                        
                    let basic  = {no:data.id,area_name:data.name,data:data};                                          
                    let basic1 = {}; let basic2 = {};
                    data.calons.forEach(calon=>{
                      basic1['real_0'+String(calon.no)] = calon.hitung.suara;
                    });
                    data.kpucalons = [];  
                    for(var key in fm.kpudata.table[data.id]){
                      let chart = fm.kpudata.table[data.id];  
                      if(key === "persen") {
                        basic.persen = chart[key].toFixed(2);
                        continue;
                      }                                                
                      data.kpucalons.push({id:key, no:this.kpucalons[key].nomor_urut, name:this.kpucalons[key].nama , suara: chart[key], color:this.kpucalons[key].warna});
                      basic2['kpu_'+this.kpucalons[key].nomor_urut] = chart[key];
                    }   
                    
                    basic = {...basic, ...basic1};
                    basic = {...basic, ...basic2};
                    fm.tablebody.push(basic);
                  });
                } else {
                  let kputable = [];
                  let kputpsid = [];
                  for(var tps_id in fm.kpudata.table){
                    kputable.push(fm.kpudata.table[tps_id]);
                    kputpsid.push(tps_id);
                  }
                  fm.area.data.forEach((data,i)=>{    
                    let basic  = {no:data.id,area_name:data.name,data:data};                                          
                    let basic1 = {}; let basic2 = {};
                    data.calons.forEach(calon=>{
                      basic1['real_0'+String(calon.no)] = calon.hitung.suara;
                    });
                    
                    data.kpucalons = [];                              
                    for(var key in kputable[i]){
                      let chart = kputable[i];
                      if(key === "persen") {
                        basic.persen = chart[key].toFixed(2);
                        continue;
                      }                        
                      data.kputpsid = kputpsid[i];
                      data.kpuurl   = fm.kpuurl+'/'+data.kputpsid;
                      data.kpucalons.push({id:key, no:this.kpucalons[key].nomor_urut, name:this.kpucalons[key].nama , suara: chart[key], color:this.kpucalons[key].warna});
                      basic2['kpu_'+this.kpucalons[key].nomor_urut] = chart[key];
                    }   
                    
                    basic = {...basic, ...basic1};
                    basic = {...basic, ...basic2};
                    fm.tablebody.push(basic);
                  });
                }
                
                if(reset && fm.area.data.length == 0) {fm.area.page = 1;}
                this.loading = false;
            });
        },                                
        
        setPieOption(data, quickcountMode=false){
            //let ctx = this; setTimeout(function(){
          
            let newOption  = JSON.parse(JSON.stringify(DPie.option));
            let seriesData = [], legendData = [];        
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value :null;
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);                
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
            
            //}, 500);
        },
        
        setPieOptionKpu(data){
            //let ctx = this; setTimeout(function(){
          
            let newOption  = JSON.parse(JSON.stringify(DPie.option));
            let seriesData = [], legendData = [];        
            data.kpucalons.forEach(item=>{                
                var value = item.suara; 
                value = value > 0 ? value :null;
                var name  = item.name;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);               
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;                  
            return newOption;
            
            //}, 500);
        },
        
        setPieOption2(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DPie2.option));
            let seriesData = [], legendData = []; this.calons = [];        
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara;   
                value = value > 0 ? value :null;
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);                
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        setPieOption2Kpu(data){            
            let newOption  = JSON.parse(JSON.stringify(DPie2.option));
            let seriesData = [], legendData = []; this.calons = [];        
            data.kpucalons.forEach(item=>{                 
                var value = item.suara; 
                value = value > 0 ? value :null;
                var name  = item.name;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(name);               
            });
            newOption.series[0].data = seriesData;      
            newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        isMatching(data){
            let sisCalons = data.calons;
            let kpuCalons = data.kpucalons;
            if(parseInt(sisCalons[0].hitung.suara) === parseInt(kpuCalons[0].suara)){
                if(parseInt(sisCalons[1].hitung.suara) === parseInt(kpuCalons[1].suara)){
                    return 2;
                }
                return 1; 
            }
            else if(parseInt(sisCalons[1].hitung.suara) === parseInt(kpuCalons[1].suara)){
                if(parseInt(sisCalons[0].hitung.suara) === parseInt(kpuCalons[0].suara)){
                    return 2;
                }
                return 1; 
            }
            return 0;  
        },
        
        areaRoute (id, tingkat) {
            this.$router.push({path:'/dashboard/explore', query: {kompetisi_id: id, tingkat: tingkat}});
        },                
        
        formRoute(tps_id){
            let q = this.$route.query;
            this.$router.push({path:'/hitung/form', query: {
                kompetisi_id : q.kompetisi_id,
                mode : this.kompetisi.mode,
                tps_id : tps_id, 
            }});
        },
        
        hitungRoute(area_ids, tingkat_ids){
            let q = this.$route.query;
            this.$router.push({path:'/matching/explore', query: {
                kompetisi_id : q.kompetisi_id,
                mode : q.mode,
                tingkat : q.tingkat,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var k=0; k<arrA.length; k++){
              result.push({a:arrA[k], b:arrB[k]});
            }            
            return result;            
        }
    }
}
</script>
<style>
  .tb-berlebih{
      margin-left:auto; 
      margin-right:auto;
  }    
  .tb-berlebih td{
      padding: 5px 10px;
  }
  .cursor{
    cursor:pointer
  }
</style>  
